import {ReactElement} from 'react'
import {Trans, WithNamespaces, withNamespaces} from 'react-i18next'
import {Table, TableBody, TableCell, TableHead, TableRow} from '@material-ui/core'
import messages from '../../../../../../../assets/messages'
import Amount from '../../../../../../Common/Amount'
import {EmptyTableResults} from '../../../../../../Common/EmptyTableResults'
import {formatDate} from '../../../../../../../common/utils'
import {SortApi} from '../../../../../../../shared/hooks/useSort'
import {SortableFields, PerformanceFeeDeposit} from '../../types'
import {TableSortCell} from '../TableSortCell'
import {useStyles} from './styles'

type TabelContentProps = {
  offerName: string
  deposits: PerformanceFeeDeposit[]
  sortApi: SortApi<SortableFields>
} & WithNamespaces

function TableContentBase(props: TabelContentProps): ReactElement {
  const {offerName, deposits, sortApi, lng} = props

  const classNames = useStyles()

  if (deposits.length === 0) return <EmptyTableResults />

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell className={classNames.header}>
            <Trans {...messages.strategyName} />
          </TableCell>
          <TableCell className={classNames.header}>
            <Trans {...messages.followerName} />
          </TableCell>
          <TableCell className={classNames.header}>
            <TableSortCell orderBy='amount' sortApi={sortApi}>
              <Trans {...messages.performanceFee} />
            </TableSortCell>
          </TableCell>
          <TableCell className={classNames.header}>
            <TableSortCell orderBy='completedAt' sortApi={sortApi} >
              <Trans {...messages.transactionDate} />
            </TableSortCell>
          </TableCell>
          <TableCell className={classNames.header}>
            <Trans {...messages.reference} />
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {deposits.map(deposit => {
            const {
              id,
              followerName,
              amount,
              currency,
              completedAt,
              reference,
            } = deposit

            return (
              <TableRow key={id}>
                <TableCell className={classNames.content}>
                  {offerName ?? '-'}
                </TableCell>
                <TableCell className={classNames.content}>
                  {followerName ?? '-'}
                </TableCell>
                <TableCell className={classNames.content}>
                  <Amount value={amount} currency={currency} locale='en-US' />
                </TableCell>
                <TableCell className={classNames.content}>
                  {completedAt != null ? formatDate(lng, completedAt, {dateStyle: 'medium', timeStyle: 'short'}) : '-'}
                </TableCell>
                <TableCell className={classNames.content}>
                  {reference ?? id}
                </TableCell>
              </TableRow>
            )
          })}
      </TableBody>
    </Table>
  )
}

export const TableContent = withNamespaces()(TableContentBase)
